<!-- SPDX-License-Identifier: Apache-2.0 -->
<app-header></app-header>
<main class="mat-typography">
  <app-sidenav>
    <article appNavigationTarget id="info">
      <app-info></app-info>
    </article>

    <article appNavigationTarget id="servers">
      <app-servers></app-servers>
    </article>

    <article appNavigationTarget id="channels">
      <app-channels> </app-channels>
    </article>

    <article appNavigationTarget id="schemas">
      <app-schemas></app-schemas>
    </article>
  </app-sidenav>
</main>
